import AutoSuggest from "autosuggest.class";

module.exports = {
    init: el => {
        new AutoSuggest(el);
    }
};